<template>
  <div class="columns is-multiline">
    <div class="column is-10">
      <div class="columns">
        <div class="column is-9">
          <b-pagination
            :total="fetchCliparts.length"
            v-model="current_clipart_page"
            :per-page="clipart_page_items"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
          </b-pagination>
        </div>
        <div class="column is-1 mt-1">
          <up-numberinput
            v-model="current_clipart_page"
            size="xs"
            labelIcon=""
          ></up-numberinput>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          v-for="clipart in currentPageCliparts"
          :key="clipart._id"
          style="position: relative;border: 1px solid #ccc;"
          class="column is-2 has-text-centered clipart-cell"
        >
          <show-image @click.native="selectClipart(clipart)" width="80" :src="clipart.file" />
        </div>
      </div>
    </div>

    <div class="column is-2">
      <p class="title is-6 mt-1">Selected Clipart</p>
      <div
        v-if="current_clipart && current_clipart.clipart"
        class="columns mt-6 is-multiline"
      >
        <div
          style="position: relative;border: 1px solid #ccc;"
          class="column is-10 has-text-centered"
        >
          <show-image class="selected-clipart" :src="current_clipart.clipart.file" />
          <p>Clipart</p>
          <b-field grouped expanded>
            <b-field label="Width" expanded>
              <b-numberinput
                :controls="false"
                size="is-small"
                v-model="current_clipart.width"
              ></b-numberinput>
            </b-field>
            <b-field label="Height" expanded>
              <b-numberinput
                :controls="false"
                size="is-small"
                v-model="current_clipart.height"
              ></b-numberinput>
            </b-field>
          </b-field>
          <p>
            <b-button
              @click="removeClipart()"
              type="is-danger"
              size="is-small"
              outlined
              >Remove</b-button
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import ShowImage from '@/components/General/ShowImage'
export default {
  name: "clipart-selector",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    UpNumberinput,
    ShowImage
  },
  data() {
    return {
      current_clipart: this.value
        ? this.value
        : {
            width: 50,
            height: 50,
            clipart: null,
          },
      clipart_page_items: 50,
      current_clipart_page: 1,
    };
  },
  computed: {
    ...mapGetters(["fetchCliparts", "getTeacherToken"]),
    currentPageCliparts() {
      // Returns all cliparts of this particular page
      return this.fetchCliparts.slice(
        (this.current_clipart_page - 1) * this.clipart_page_items,
        this.current_clipart_page * this.clipart_page_items
      );
    },
  },
  methods: {
    ...mapActions(["loadCliparts"]),
    selectClipart(clipart) {
      this.current_clipart = {
        clipart,
        width: 50,
        height: 50,
      };
      this.$emit("input", this.current_clipart);
    },
    removeClipart() {
      this.current_clipart = null;
      this.$emit("input", this.current_clipart);
    },
  },
  watch: {
    value: function(new_val) {
      this.current_clipart = new_val;
    },
  },
  created() {
    this.loadCliparts({ token: this.getTeacherToken });
  },
};
</script>

<style scoped>
.clipart-cell {
  max-height: 70px;
  max-width: 70px;
  padding: 4px;
  margin: 0;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.clipart-cell:hover {
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px,
    rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px,
    rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}
.selected-clipart {
  max-width: 80px;
  max-height: 80px;
  padding: 0px;
  margin: 0;
}
</style>
